var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(
        Vendd.OfferSubscription.Messages.SubscribeToOffer,
        Vendd.OfferSubscription,
        function (envelope) {

            var options = {
                method: 'POST',
                url: 'api/OfferSubscription/SubscribeToOffer',
                data: envelope.message.data,
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {
                if (!response.success) {
                    return Vendd.MessageBus.publishAsync(
                        Vendd.OfferSubscription,
                        new Vendd.OfferSubscription.Messages.SubscribeToOfferFailure(response)
                    );
                }

                return Vendd.MessageBus.publishAsync(
                    Vendd.OfferSubscription,
                    new Vendd.OfferSubscription.Messages.SubscribeToOfferSuccess(response.message)
                );
            }

            function onFailure(response) {
                return Vendd.MessageBus.publishAsync(
                    Vendd.OfferSubscription,
                    new Vendd.OfferSubscription.Messages.SubscribeToOfferFailure(response)
                );
            }

            Vendd.Service.call(options);
        }
    );

    return Vendd;

})(Vendd || {});
